import { useEffect } from 'react';

type UseGa = {
  action: string;
  event_category: string;
  event_label: string;
};

export const useGA = ({
  action,
  event_category,
  event_label,
  fireOnMount,
}: UseGa & { fireOnMount?: boolean }): {
  fireEvent: (additionalInfo: Record<string, string | number>) => void;
} => {
  const fireEvent = (additionalInfo?: Record<string, string | number>): void => {
    // Google Analytics event tracking
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', action, {
        event_category,
        event_label,
        ...(additionalInfo ? additionalInfo : {}),
      });
    }
  };

  useEffect(() => {
    fireOnMount && fireEvent();
  }, []);

  return { fireEvent };
};
